// src/mixins/breakpoints.ts
import { Breakpoint } from "@deliveryhero/armor-tokens";
var edgeValue = 0.05;
var breakpointUnit = "px";
var defaultMediaPrefix = "@media";
var defaultBreakpointValues = {
  xs: Breakpoint.breakpointXsmall,
  sm: Breakpoint.breakpointSmall,
  md: Breakpoint.breakpointMedium,
  lg: Breakpoint.breakpointLarge,
  xl: Breakpoint.breakpointXlarge,
  "2xl": Breakpoint.breakpoint2xlarge
};
var getBreakPointValues = function getBreakPointValues(theme) {
  if (!theme) {
    return defaultBreakpointValues;
  }
  if (theme.isLegacy) {
    return theme.breakpoints;
  }
  var _theme$breakpoint = theme.breakpoint,
    breakpointXsmall = _theme$breakpoint.breakpointXsmall,
    breakpointSmall = _theme$breakpoint.breakpointSmall,
    breakpointMedium = _theme$breakpoint.breakpointMedium,
    breakpointLarge = _theme$breakpoint.breakpointLarge,
    breakpointXlarge = _theme$breakpoint.breakpointXlarge,
    breakpoint2xlarge = _theme$breakpoint.breakpoint2xlarge;
  return {
    xs: breakpointXsmall,
    sm: breakpointSmall,
    md: breakpointMedium,
    lg: breakpointLarge,
    xl: breakpointXlarge,
    "2xl": breakpoint2xlarge
  };
};
var mapBreakpointCodeToValue = function mapBreakpointCodeToValue(value, spacing) {
  return function (_ref) {
    var theme = _ref.theme;
    var breakpointValues = getBreakPointValues(theme == null ? void 0 : theme.armor);
    if (typeof value === "string" && value in breakpointValues) {
      return "".concat(breakpointValues[value], "px");
    }
    return spacing ? spacing(value) : value;
  };
};
var mapBreakpointWidthToCode = function mapBreakpointWidthToCode(width) {
  return function (_ref2) {
    var theme = _ref2.theme;
    var widthProp = width;
    var values = getBreakPointValues(theme == null ? void 0 : theme.armor);
    var keys = Object.keys(values);
    if (typeof widthProp !== "number") {
      widthProp = parseInt(widthProp, 10);
    }
    if (widthProp <= 0) {
      return keys[0];
    }
    if (widthProp >= values[keys[keys.length - 1]]) {
      return keys[keys.length - 1];
    }
    for (var i = 0; i < keys.length; i += 1) {
      var keyStart = keys[i];
      var keyEnd = keys[i + 1];
      if (widthProp >= values[keyStart] && widthProp < values[keyEnd]) {
        return keyStart;
      }
    }
    return "";
  };
};
var breakpointUp = function breakpointUp(breakpoint) {
  var prefix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : defaultMediaPrefix;
  return function (_ref3) {
    var theme = _ref3.theme;
    var values = getBreakPointValues(theme == null ? void 0 : theme.armor);
    if (!(breakpoint in values)) {
      return "";
    }
    return "".concat(prefix, " (min-width:").concat(values[breakpoint]).concat(breakpointUnit, ")");
  };
};
var breakpointDown = function breakpointDown(breakpoint) {
  var prefix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : defaultMediaPrefix;
  return function (_ref4) {
    var theme = _ref4.theme;
    var values = getBreakPointValues(theme == null ? void 0 : theme.armor);
    var keys = Object.keys(values);
    if (!(breakpoint in values)) {
      return "";
    }
    var rightIndex = keys.indexOf(breakpoint);
    var rightValue = values[keys[rightIndex]];
    if (rightIndex === keys.length) {
      return breakpointUp("xs", prefix);
    }
    if (!(typeof rightValue !== "undefined" && rightIndex > 0)) {
      return "";
    }
    return "".concat(prefix, " (max-width:").concat(rightValue - edgeValue).concat(breakpointUnit, ")");
  };
};
var breakpointBetween = function breakpointBetween(breakpointStart, breakpointEnd) {
  var prefix = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : defaultMediaPrefix;
  return function (_ref5) {
    var theme = _ref5.theme;
    var values = getBreakPointValues(theme == null ? void 0 : theme.armor);
    var keys = Object.keys(values);
    var rightIndex = keys.indexOf(breakpointEnd);
    if (rightIndex === keys.length - 1) {
      return breakpointUp(breakpointStart, prefix);
    }
    return "".concat(prefix, " (min-width:").concat(values[breakpointStart]).concat(breakpointUnit, ") and (max-width:").concat(values[keys[rightIndex + 1]] - edgeValue).concat(breakpointUnit, ")");
  };
};
var breakpointOnly = function breakpointOnly(breakpoint) {
  var prefix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : defaultMediaPrefix;
  return breakpointBetween(breakpoint, breakpoint, prefix);
};
var mediaQuery = {
  mapCodeToValue: mapBreakpointCodeToValue,
  mapWidthToCode: mapBreakpointWidthToCode,
  up: breakpointUp,
  down: breakpointDown,
  only: breakpointOnly,
  between: breakpointBetween
};
export { edgeValue, breakpointUnit, defaultMediaPrefix, defaultBreakpointValues, getBreakPointValues, mapBreakpointCodeToValue, mapBreakpointWidthToCode, breakpointUp, breakpointDown, breakpointBetween, breakpointOnly, mediaQuery };